// extracted by mini-css-extract-plugin
export var actionButton = "_kw-t";
export var buttonContainer = "_kw-0";
export var buttonContainer2 = "_kw-1";
export var buttonSection = "_kw-2";
export var details = "_kw-3";
export var dropdownItem = "_kw-5";
export var dropdownItemsContainer = "_kw-4";
export var fileInput = "_kw-r";
export var headerButton = "_kw-6";
export var icon = "_kw-7";
export var input = "_kw-8";
export var macroListItem = "_kw-9";
export var mainContent = "_kw-a";
export var microText = "_kw-b";
export var modal = "_kw-w";
export var optionsButton = "_kw-c";
export var paperclip = "_kw-s";
export var pillContent = "_kw-d";
export var preview = "_kw-e";
export var preview2 = "_kw-f";
export var quillEditor = "_kw-q";
export var selectedMacro = "_kw-g";
export var sidebar = "_kw-h";
export var sidebarHeader = "_kw-j";
export var sidebarList = "_kw-i";
export var sidebarListItem = "_kw-k";
export var sidebarSearch = "_kw-l";
export var snoozeDurationWrapper = "_kw-v";
export var statusPillContainer = "_kw-m";
export var tagsContainer = "_kw-n";
export var unselectedMacro = "_kw-o";
export var variable = "_kw-u";
export var wrapper = "_kw-p";